import { render, staticRenderFns } from "./lhc_time.vue?vue&type=template&id=33987cad&scoped=true"
import script from "./lhc_time.vue?vue&type=script&lang=js"
export * from "./lhc_time.vue?vue&type=script&lang=js"
import style0 from "./lhc_time.vue?vue&type=style&index=0&id=33987cad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33987cad",
  null
  
)

export default component.exports